module.exports = __webpack_public_path__ + "static/media/Donaldo.358a2035.png";